import { configureStore, type StoreEnhancer } from '@reduxjs/toolkit';

import {
	commandApiSlice,
	coreApiSlice,
	notificationApiSlice,
	orchApiSlice,
	queryApiSlice,
	walletApiSlice,
} from '@/store/api/apiSlice';

import monitorReducerEnhancer from './enhancers/monitorReducer';
import loggerMiddleware from './middleware/logger';
import reducers from './reducers/rootreducer';

const store = configureStore({
	reducer: reducers,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			// RTK includes redux-thunk by default, so we don't need to add it
			serializableCheck: {
				// Ignore these action types if you have non-serializable data
				ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
			},
		})
			.concat(
				walletApiSlice.middleware,
				coreApiSlice.middleware,
				queryApiSlice.middleware,
				commandApiSlice.middleware,
				orchApiSlice.middleware
			)
			.concat(loggerMiddleware),
	enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(monitorReducerEnhancer as StoreEnhancer),
	devTools: process.env.NODE_ENV !== 'production',
});

export default function configureAppStore(preloadedState?: any) {
	return configureStore({
		reducer: reducers,
		preloadedState,
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				serializableCheck: {
					ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
				},
			})
				.concat(
					walletApiSlice.middleware,
					coreApiSlice.middleware,
					queryApiSlice.middleware,
					commandApiSlice.middleware,
					orchApiSlice.middleware,
					notificationApiSlice.middleware
				)
				.concat(loggerMiddleware),
		enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(monitorReducerEnhancer as StoreEnhancer),
		devTools: process.env.NODE_ENV !== 'production',
	});
}

// Export types for TypeScript usage
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
